// ONIMA Minor Arcana - 56 cards
// Generated 2026-02-26

export const MINOR_ARCANA = {
  // === WANDS (Fire) ===
  wands_ace: {
    name: "Ace of Wands",
    name_ru: "Туз Жезлов",
    suit: "wands",
    number: 1,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/f32d212ea6abb00285b9f5ad4ff6a51bb831d12e5bf65b1199ca08e6cd8eeac7.png",
  },
  wands_two: {
    name: "Two of Wands",
    name_ru: "Двойка Жезлов",
    suit: "wands",
    number: 2,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/607a2cf4fb4f1e9c82a7f180baa339f875033db88d15591f69d32e84fd726343.png",
  },
  wands_three: {
    name: "Three of Wands",
    name_ru: "Тройка Жезлов",
    suit: "wands",
    number: 3,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/ca9b74d94759991c9f42dcd2dfe346ad0de0002bc790f1bc46986915d3d54b6a.png",
  },
  wands_four: {
    name: "Four of Wands",
    name_ru: "Четвёрка Жезлов",
    suit: "wands",
    number: 4,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/ad4c16be126ffda74690037b5398ae793e9eccb108ca738fc6b9b5d894b5e946.png",
  },
  wands_five: {
    name: "Five of Wands",
    name_ru: "Пятёрка Жезлов",
    suit: "wands",
    number: 5,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/dc7ace5b61269d817c2b44204145b3cdc96d9cc3bbcdad0af7c251b8d07a259d.png",
  },
  wands_six: {
    name: "Six of Wands",
    name_ru: "Шестёрка Жезлов",
    suit: "wands",
    number: 6,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/bfcbf6d24b5feffa769836081c8c5ca40e93a0d4f8eaf675034c22fc897060ef.png",
  },
  wands_seven: {
    name: "Seven of Wands",
    name_ru: "Семёрка Жезлов",
    suit: "wands",
    number: 7,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/fa637fb3e5b2d32ac8a3e4d99afd23b49999ed4b366eddc7e9c29a9b63466d79.png",
  },
  wands_eight: {
    name: "Eight of Wands",
    name_ru: "Восьмёрка Жезлов",
    suit: "wands",
    number: 8,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/de45b0a2b99b67223c5f39aa5fa9128ad56d08c023aba821ceacaee4fcbdfe43.png",
  },
  wands_nine: {
    name: "Nine of Wands",
    name_ru: "Девятка Жезлов",
    suit: "wands",
    number: 9,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/f17917be69b550b2108f4ce8d5fda44aedee957087b78966ad360d66dddc70f5.png",
  },
  wands_ten: {
    name: "Ten of Wands",
    name_ru: "Десятка Жезлов",
    suit: "wands",
    number: 10,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/b840849f02dc833cd343b413db81df94815ba21ec870275aa82ea71859646f67.png",
  },
  wands_page: {
    name: "Page of Wands",
    name_ru: "Паж Жезлов",
    suit: "wands",
    number: 11,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/ab7f20d20f50a9af7815eecc08cd344d13d58bf5d32e3a82464bd482c2ceaa89.png",
  },
  wands_knight: {
    name: "Knight of Wands",
    name_ru: "Рыцарь Жезлов",
    suit: "wands",
    number: 12,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/17b37daa52387e681dc0431e759f525366259edb668c33986ae8ad66b053090c.png",
  },
  wands_queen: {
    name: "Queen of Wands",
    name_ru: "Королева Жезлов",
    suit: "wands",
    number: 13,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/aad7ef463d0d432baf7fc7feaf661b80455638740c866b137b2ce64f7b557ed9.png",
  },
  wands_king: {
    name: "King of Wands",
    name_ru: "Король Жезлов",
    suit: "wands",
    number: 14,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/5e6567d6f1049a95e81d2901f429b8d1865ec979d2538c914c80aa3d06375e13.png",
  },

  // === CUPS (Water) ===
  cups_ace: {
    name: "Ace of Cups",
    name_ru: "Туз Кубков",
    suit: "cups",
    number: 1,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/8ed9bd610edfc9b72c065ca9bdf35b8e9b118f6a13f15562bb7df5bf83f03c73.png",
  },
  cups_two: {
    name: "Two of Cups",
    name_ru: "Двойка Кубков",
    suit: "cups",
    number: 2,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/b6b08bb2e154d3ff7e25239c60b252a1475ecbb834c3dc7d2091355f85765aa8.png",
  },
  cups_three: {
    name: "Three of Cups",
    name_ru: "Тройка Кубков",
    suit: "cups",
    number: 3,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/cb2aced3afbedeca25537cc4b8ff5908a73f76199c18e29b5b6af5073bfb7604.png",
  },
  cups_four: {
    name: "Four of Cups",
    name_ru: "Четвёрка Кубков",
    suit: "cups",
    number: 4,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/d3798a59d07c78b4faf0b53d6904aef62ef5800e96ea6e1e38dc18ea4585eb96.png",
  },
  cups_five: {
    name: "Five of Cups",
    name_ru: "Пятёрка Кубков",
    suit: "cups",
    number: 5,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/98d7e3b95e1598bbabb9bbc34bb9c0ef334c7ee6adafd8206c5165dac81904b1.png",
  },
  cups_six: {
    name: "Six of Cups",
    name_ru: "Шестёрка Кубков",
    suit: "cups",
    number: 6,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/c20399e059d6466e6ebf0cf3ed075f79f265bb3040d6f0bdaf755cac28328ace.png",
  },
  cups_seven: {
    name: "Seven of Cups",
    name_ru: "Семёрка Кубков",
    suit: "cups",
    number: 7,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/169bfb9813e29c6ce0d6fc22271bf94edae89daa34b511c67ae17f4ec545381c.png",
  },
  cups_eight: {
    name: "Eight of Cups",
    name_ru: "Восьмёрка Кубков",
    suit: "cups",
    number: 8,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/d554a512ba1654557070118a6a55b53149bbcacff4594222de201e1bad3c097e.png",
  },
  cups_nine: {
    name: "Nine of Cups",
    name_ru: "Девятка Кубков",
    suit: "cups",
    number: 9,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/3813f18482f577c2a0774c3a1963884ca8659e5d17aa4621536d34556a4df849.png",
  },
  cups_ten: {
    name: "Ten of Cups",
    name_ru: "Десятка Кубков",
    suit: "cups",
    number: 10,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/43190290ce42d44d0373e84b60092bfdfb623705269df73a4f6028dbfdde00c6.png",
  },
  cups_page: {
    name: "Page of Cups",
    name_ru: "Паж Кубков",
    suit: "cups",
    number: 11,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/1514ac0f435438ed6a7f1d1dda3b1442e4f06a0b42cf85ee1efea29f6103fe9a.png",
  },
  cups_knight: {
    name: "Knight of Cups",
    name_ru: "Рыцарь Кубков",
    suit: "cups",
    number: 12,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/f46a5714a00a8dc924239449bae9a332c0ca1ce04e1aaf4164c84b652ff0b3f3.png",
  },
  cups_queen: {
    name: "Queen of Cups",
    name_ru: "Королева Кубков",
    suit: "cups",
    number: 13,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/138420a03d72d65ae943bea8f8d8d823edb33872ac85146c4f382d4e0e3343a4.png",
  },
  cups_king: {
    name: "King of Cups",
    name_ru: "Король Кубков",
    suit: "cups",
    number: 14,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/96edb2ac1110ab4a54c083ace1c1473527d13dac7e79445bf1d5e83f4fd89669.png",
  },

  // === SWORDS (Air) ===
  swords_ace: {
    name: "Ace of Swords",
    name_ru: "Туз Мечей",
    suit: "swords",
    number: 1,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/1c250677dbc24e9936840731be71c1798044d1aa69c969ee039a41eab472f795.png",
  },
  swords_two: {
    name: "Two of Swords",
    name_ru: "Двойка Мечей",
    suit: "swords",
    number: 2,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/3ea5a0e91c88454e2ed8c94246aeeb19fabc14293f440c4d702b2d2d8ac4ab6b.png",
  },
  swords_three: {
    name: "Three of Swords",
    name_ru: "Тройка Мечей",
    suit: "swords",
    number: 3,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/f0d80193ccfa284b84abeae56325e0681c0e9e957bfbf8075e9700e96586f0f0.png",
  },
  swords_four: {
    name: "Four of Swords",
    name_ru: "Четвёрка Мечей",
    suit: "swords",
    number: 4,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/0d7c955941b02aa294c68ffbf1edaa240f525f18087d03cd3ffbde531c143c5f.png",
  },
  swords_five: {
    name: "Five of Swords",
    name_ru: "Пятёрка Мечей",
    suit: "swords",
    number: 5,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/0fc139668c3ebf3f56061deba315eaae3491ab1c196ff91a30d2d0f58b1f8ad2.png",
  },
  swords_six: {
    name: "Six of Swords",
    name_ru: "Шестёрка Мечей",
    suit: "swords",
    number: 6,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/0923942a78e36acb8716194af90891f3c7936cf478cdb59f6cffc5385a0753bd.png",
  },
  swords_seven: {
    name: "Seven of Swords",
    name_ru: "Семёрка Мечей",
    suit: "swords",
    number: 7,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/265f24fdaf558752aa66c18c158e188333d4a16b62fcd1257e4f848156d2b438.png",
  },
  swords_eight: {
    name: "Eight of Swords",
    name_ru: "Восьмёрка Мечей",
    suit: "swords",
    number: 8,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/7fb723f265e2b34e41e78780c3426b3a11c31b2609d19c7f604409a157dd4d7a.png",
  },
  swords_nine: {
    name: "Nine of Swords",
    name_ru: "Девятка Мечей",
    suit: "swords",
    number: 9,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/0762b6d9d03f1d90c37fa55c8d2502c45f5d6781c75ca11972a6f80a3946494e.png",
  },
  swords_ten: {
    name: "Ten of Swords",
    name_ru: "Десятка Мечей",
    suit: "swords",
    number: 10,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/f8f5742e609cc45c7a892fdf38f7369120b73c018c06c93c1d76f965a187e800.png",
  },
  swords_page: {
    name: "Page of Swords",
    name_ru: "Паж Мечей",
    suit: "swords",
    number: 11,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/16e2b1fd31991817b236bcacd3ebdbfc531b18d4e0eb99b52b8f2a282eead472.png",
  },
  swords_knight: {
    name: "Knight of Swords",
    name_ru: "Рыцарь Мечей",
    suit: "swords",
    number: 12,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/a04afe9716ec98c3a7ed73e347466156335281ba332133b71a8789265e0b830c.png",
  },
  swords_queen: {
    name: "Queen of Swords",
    name_ru: "Королева Мечей",
    suit: "swords",
    number: 13,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/3c6d3e908c7fce9024d71a174adf4c337253765b515c131fbf11f4e7b03a5fa8.png",
  },
  swords_king: {
    name: "King of Swords",
    name_ru: "Король Мечей",
    suit: "swords",
    number: 14,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/ae01c00f4e27ea3133c5e72575344a0d2628bee04d65a29a0cfae288cafb3606.png",
  },

  // === PENTACLES (Earth) ===
  pentacles_ace: {
    name: "Ace of Pentacles",
    name_ru: "Туз Пентаклей",
    suit: "pentacles",
    number: 1,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/786e964b86099d3e1e319468cbe62987f1c3c741509573531a42aaa3587b3614.png",
  },
  pentacles_two: {
    name: "Two of Pentacles",
    name_ru: "Двойка Пентаклей",
    suit: "pentacles",
    number: 2,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/a9473ef35a499c86d713dcd0fcfa676b38a2fdb4ec88a79960ddc1a7f1800dae.png",
  },
  pentacles_three: {
    name: "Three of Pentacles",
    name_ru: "Тройка Пентаклей",
    suit: "pentacles",
    number: 3,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/b029941183cd70130665bb74eafd5ac459ffb6459cef4aa2d0c5be5bbb7e6503.png",
  },
  pentacles_four: {
    name: "Four of Pentacles",
    name_ru: "Четвёрка Пентаклей",
    suit: "pentacles",
    number: 4,
    image: "https://static.prod-images.emergentagent.com/jobs/f4b808a9-f806-47e0-8566-d0daf94a420a/images/0bab3113a4bbb9460c4e96aef7d251f6f35f9ce3ef0dd4765c9bdaae122ace2b.png",
  },
  pentacles_five: {
    name: "Five of Pentacles",
    name_ru: "Пятёрка Пентаклей",
    suit: "pentacles",
    number: 5,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/76893a00012882ca97bf1e2ab915006a41d40d4f73d1d182090191cdda9da689.png",
  },
  pentacles_six: {
    name: "Six of Pentacles",
    name_ru: "Шестёрка Пентаклей",
    suit: "pentacles",
    number: 6,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/79f5f60f95e97331921a5faca61e29f784f3dfdd11d41cd5f733b3963c7da990.png",
  },
  pentacles_seven: {
    name: "Seven of Pentacles",
    name_ru: "Семёрка Пентаклей",
    suit: "pentacles",
    number: 7,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/946f36dc84013b1e053af8b08121ff637c11d5e3ad65ecb297df3cd3026431f2.png",
  },
  pentacles_eight: {
    name: "Eight of Pentacles",
    name_ru: "Восьмёрка Пентаклей",
    suit: "pentacles",
    number: 8,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/0529a630c3147cd9b05bce39546a16bee78c92071d504db217367f5dde93b2fc.png",
  },
  pentacles_nine: {
    name: "Nine of Pentacles",
    name_ru: "Девятка Пентаклей",
    suit: "pentacles",
    number: 9,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/89a38716229fbd2de03d97e67af9f92b37f2650b0f38a9d002f3c36fd4b0895a.png",
  },
  pentacles_ten: {
    name: "Ten of Pentacles",
    name_ru: "Десятка Пентаклей",
    suit: "pentacles",
    number: 10,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/17259b95071bf36d322dfc32bde77cccc419e9ebd0bf1ed88ba874d9273eeca0.png",
  },
  pentacles_page: {
    name: "Page of Pentacles",
    name_ru: "Паж Пентаклей",
    suit: "pentacles",
    number: 11,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/aea583cedd33e78130d91beb6b13c06762b508ee087e62dfc0853c38a8655a82.png",
  },
  pentacles_knight: {
    name: "Knight of Pentacles",
    name_ru: "Рыцарь Пентаклей",
    suit: "pentacles",
    number: 12,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/99ceb28e79a71a7f10ccd1e2338ff624599c3c0883921c6df2ecc4d0eba5011e.png",
  },
  pentacles_queen: {
    name: "Queen of Pentacles",
    name_ru: "Королева Пентаклей",
    suit: "pentacles",
    number: 13,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/e71ba63e3026bfa739e0f5a15913626b0e06a0c231479315ee24c6b5ab7eaf34.png",
  },
  pentacles_king: {
    name: "King of Pentacles",
    name_ru: "Король Пентаклей",
    suit: "pentacles",
    number: 14,
    image: "https://static.prod-images.emergentagent.com/jobs/b248d5ec-caf9-48af-8310-27a625f33b87/images/4f099c603fd5278bf0a9405b77e4a0af4b41bf3110d74f6c493fb42d0c9d668f.png",
  },
};

// Helper to get all cards as array
export const getAllMinorArcana = () => Object.values(MINOR_ARCANA);

// Get cards by suit
export const getCardsBySuit = (suit) => 
  Object.values(MINOR_ARCANA).filter(card => card.suit === suit);

export default MINOR_ARCANA;
